import componentFn from '../../styles/objects/component'
import { important } from '../../styles/tools/parsers'
import breakTo from '../../styles/tools/breakTo'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const component = componentFn({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  })

  // const keyframes = {
  //   spinner: {
  //     to: {
  //       transform: 'rotate(360deg)'
  //     }
  //   }
  // }

  const styles = {
    uploader: {
      height: '15rem',
      margin: '1rem 0 2rem',

      color: colors.fileUpload.bg,
      border: `2px dashed ${colors.fileUpload.border.default}`,
      borderRadius: '4px',
      backgroundColor: colors.fileUpload.bg,
      backgroundImage: images.documents.tris,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 35%',
      backgroundSize: '10rem'

      // [breakTo('smaller')]: {
      //   float: 'left',

      //   width: '41%',
      //   margin: '0 .5rem',
      // }
    },
    'uploader--license-front': {
      backgroundImage: images.documents.patenteFronte
    },
    'uploader--license-back': {
      backgroundImage: images.documents.patenteRetro
    },
    'uploader--idcard-front': {
      backgroundImage: images.documents.cartaIdentitaFronte
    },
    'uploader--idcard-back': {
      backgroundImage: images.documents.cartaIdentitaRetro
    },
    'uploader--passport-front': {
      backgroundImage: images.documents.passaportoFronte
    },
    'uploader--passport-back': {
      backgroundImage: images.documents.passaportoRetro
    },
    'uploader--selfie': {
      border: `2px solid ${colors.fileUpload.border.default}`,
      backgroundImage: images.documents.selfieSelected,
      backgroundPosition: '56% 35%',
      [breakTo('smaller')]: {
        backgroundPosition: '52% 35%'
      }
    },
    'uploader--filled': {
      color: 'inherit',
      backgroundColor: colors.fileUpload.bg,
      backgroundSize: 'auto 90%',
      backgroundPosition: '50% 50%'
    },
    'uploader--loading': {
      // ':before': {
      //   content: '\'\'',
      //   boxSizing: 'border-box',
      //   position: 'absolute',
      //   top: '50%',
      //   left: '50%',
      //   width: '70px',
      //   height: '70px',
      //   marginTop: '-35px',
      //   marginLeft: '-35px',
      //   backgroundImage: images.documents.uploaderLoading,
      //   backgroundRepeat: 'no-repeat',
      //   backgroundPosition: 'center',
      //   animationName: keyframes.spinner,
      //   animationDuration: '.6s',
      //   animationTimingFunction: 'linear',
      //   animationIterationCount: 'infinite'
      // },
      position: 'relative',
      backgroundImage: important('none')
    },
    'input-file__label--filled': {
      color: 'transparent'
    },

    'uploader--error': {
      color: 'inherit',
      border: `2px dashed ${colors.fileUpload.border.error}`
    },
    'uploader--mobile': {
      color: 'inherit',
      border: `2px solid ${colors.fileUpload.border.default}`
    },
    'uploader--error-mobile': {
      color: 'inherit',
      border: `2px solid ${colors.fileUpload.border.error}`
    },
    'uploader--focus': {
      color: 'inherit',
      border: `2px dashed ${colors.fileUpload.border.focus}`
    },
    'uploader--focus-mobile': {
      color: 'inherit',
      border: `2px solid ${colors.fileUpload.border.focus}`
    },

    'input-file': {
      // lineHeight: '23rem',

      position: 'absolute',

      display: 'block',

      width: '100%',
      height: '100%',
      marginTop: '-1rem',
      marginLeft: '-.5rem',

      opacity: '0',

      cursor: 'pointer'
    },

    'input-file--out': {
      left: '-9999px',

      width: '10px',
      height: '10px',
      margin: '0',
      padding: '0'
    },

    'input-file__label': {
      fontSize: '1rem',
      lineHeight: '1.5rem',

      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',

      paddingBottom: '1rem',

      width: '100%',
      height: '100%',

      color: colors.fileUpload.text
    },

    'input-file__label--selfie': {
      maxWidth: '23.6rem',
      marginRight: 'auto',
      marginLeft: 'auto',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top center',
      textAlign: 'center'
    }
  }

  return { ...component, ...styles }
}



// WEBPACK FOOTER //
// ./components/file/styles.js